import React, { useState } from "react";

import { useNavigate } from "react-router-dom";

import course103 from "../data/courses/course103";

import TheoryQuestion from "../components/TheoryQuestion";

import "../styles/Quiz.css";

const QuizSectionB = () => {
  const navigate = useNavigate();

  const questions = course103.assessment.theory;

  const [currentQuestion, setCurrentQuestion] = useState(0);

  const [answers, setAnswers] = useState<Record<number, string>>({});

  const question = questions[currentQuestion];

  const handleChange = (value: string) => {
    const updated = {
      ...answers,
      [question.id]: value,
    };

    setAnswers(updated);

    localStorage.setItem("course103_theory_answers", JSON.stringify(updated));
  };

  const nextQuestion = () => {
    if (currentQuestion < questions.length - 1) {
      setCurrentQuestion(currentQuestion + 1);
    } else {
      navigate("/quiz/result");
    }
  };

  return (
    <div className="quiz-page">
      <h2 className="section-heads">COURSE 103 – FINAL ASSESSMENT</h2>
      <h3 className="quiz-section-title">{question.title}</h3>{" "}
      <TheoryQuestion
        questionNumber={currentQuestion + 1}
        totalQuestions={questions.length}
        question={question.question}
        answer={answers[question.id] || ""}
        onChange={handleChange}
      />
      <button className="quiz-btn" onClick={nextQuestion}>
        {currentQuestion === questions.length - 1 ? "Review & Submit" : "Next"}
      </button>
    </div>
  );
};

export default QuizSectionB;
